import { render, staticRenderFns } from "./GroupsManaging.vue?vue&type=template&id=d7cb37b0&scoped=true"
import script from "./GroupsManaging.vue?vue&type=script&lang=js"
export * from "./GroupsManaging.vue?vue&type=script&lang=js"
import style0 from "./GroupsManaging.vue?vue&type=style&index=0&id=d7cb37b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7cb37b0",
  null
  
)

export default component.exports